import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import AirportManifests from "@/pages/AirportManifests";

export default function DriverManifests() {
  const navigate = useNavigate();
  return (
    <div data-testid="driver-manifests" className="min-h-screen bg-ink-900 p-4 sm:p-6">
      <div className="no-print mx-auto mb-6 max-w-5xl">
        <Button data-testid="driver-manifests-back" variant="outline" onClick={() => navigate("/portal/driver")}
          className="border-ink-600 bg-transparent text-slate-300 hover:text-gold">
          <ArrowLeft className="mr-2 h-4 w-4" /> My trips
        </Button>
      </div>
      <div className="mx-auto max-w-5xl">
        <AirportManifests />
      </div>
    </div>
  );
}
